import React from "react";
interface folderIconSpecs {
  className?: string;
}

function FolderIcon(props: folderIconSpecs) {
  return (
    <div
      className={props.className}
      style={{
        width: "auto",
      }}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 594 670"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg
          width="594"
          height="669"
          viewBox="0 0 594 669"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_ii_269_252)">
            <path
              d="M170.229 9.58676C171.801 4.29215 177.366 1.2738 182.661 2.84508L554.412 113.17C559.706 114.741 562.725 120.307 561.153 125.602L511.274 293.675C510.576 296.026 509.039 298.038 506.954 299.33L464.655 325.54C462.57 326.832 461.033 328.844 460.335 331.195L384.221 587.671C382.65 592.966 377.084 595.984 371.789 594.413L36.6203 494.945C31.3257 493.374 28.3074 487.808 29.8786 482.513L170.229 9.58676Z"
              fill="url(#paint0_radial_269_252)"
            />
          </g>
          <g filter="url(#filter1_ii_269_252)">
            <path
              d="M589.094 146.865C591.804 147.398 593.568 150.027 593.034 152.736L510.8 570.237C510.267 572.946 507.638 574.71 504.928 574.177L85.5052 491.616C82.7957 491.083 81.0319 488.454 81.5656 485.744L163.799 68.2433C164.333 65.5339 166.962 63.7699 169.671 64.3032L589.094 146.865Z"
              fill="#FFD43B"
            />
          </g>
          <g filter="url(#filter2_ii_269_252)">
            <path
              d="M193.245 78.7933C194.031 76.146 196.813 74.6369 199.461 75.4225L566.708 184.415C569.355 185.201 570.864 187.984 570.078 190.631L449.257 597.735C448.471 600.383 445.688 601.892 443.041 601.106L75.7939 492.114C73.1466 491.328 71.6375 488.545 72.4232 485.898L193.245 78.7933Z"
              fill="#F1F3F5"
            />
          </g>
          <g filter="url(#filter3_ii_269_252)">
            <rect
              x="204.732"
              y="170.134"
              width="319.478"
              height="98.7004"
              rx="10"
              transform="rotate(16.53 204.732 170.134)"
              fill="#FFDEEB"
            />
          </g>
          <rect
            x="222.644"
            y="198.028"
            width="270.128"
            height="4.32897"
            rx="2.16448"
            transform="rotate(16.53 222.644 198.028)"
            fill="#9B6A6C"
          />
          <rect
            x="211.13"
            y="230.736"
            width="270.128"
            height="4.32897"
            rx="2.16448"
            transform="rotate(16.53 211.13 230.736)"
            fill="#9B6A6C"
          />
          <rect
            x="230.167"
            y="218.323"
            width="243.288"
            height="4.32897"
            rx="2.16448"
            transform="rotate(16.53 230.167 218.323)"
            fill="#9B6A6C"
          />
          <rect
            x="222.804"
            y="252.263"
            width="243.288"
            height="4.32897"
            rx="2.16448"
            transform="rotate(16.53 222.804 252.263)"
            fill="#9B6A6C"
          />
          <g filter="url(#filter4_ii_269_252)">
            <rect
              x="173.323"
              y="275.963"
              width="319.478"
              height="98.7004"
              rx="10"
              transform="rotate(16.53 173.323 275.963)"
              fill="#FFDEEB"
            />
          </g>
          <rect
            x="191.235"
            y="303.857"
            width="270.128"
            height="4.32896"
            rx="2.16448"
            transform="rotate(16.53 191.235 303.857)"
            fill="#9B6A6C"
          />
          <rect
            x="179.722"
            y="336.565"
            width="270.128"
            height="4.32897"
            rx="2.16449"
            transform="rotate(16.53 179.722 336.565)"
            fill="#9B6A6C"
          />
          <rect
            x="198.759"
            y="324.152"
            width="243.288"
            height="4.32897"
            rx="2.16449"
            transform="rotate(16.53 198.759 324.152)"
            fill="#9B6A6C"
          />
          <rect
            x="191.395"
            y="358.092"
            width="243.288"
            height="4.32896"
            rx="2.16448"
            transform="rotate(16.53 191.395 358.092)"
            fill="#9B6A6C"
          />
          <g filter="url(#filter5_ii_269_252)">
            <rect
              x="141.915"
              y="381.792"
              width="319.478"
              height="98.7004"
              rx="10"
              transform="rotate(16.53 141.915 381.792)"
              fill="#FFDEEB"
            />
          </g>
          <rect
            x="159.827"
            y="409.686"
            width="270.128"
            height="4.32897"
            rx="2.16449"
            transform="rotate(16.53 159.827 409.686)"
            fill="#9B6A6C"
          />
          <rect
            x="148.314"
            y="442.394"
            width="270.128"
            height="4.32897"
            rx="2.16449"
            transform="rotate(16.53 148.314 442.394)"
            fill="#9B6A6C"
          />
          <rect
            x="167.35"
            y="429.981"
            width="243.288"
            height="4.32897"
            rx="2.16449"
            transform="rotate(16.53 167.35 429.981)"
            fill="#9B6A6C"
          />
          <rect
            x="159.987"
            y="463.921"
            width="243.288"
            height="4.32897"
            rx="2.16449"
            transform="rotate(16.53 159.987 463.921)"
            fill="#9B6A6C"
          />
          <g filter="url(#filter6_ii_269_252)">
            <rect
              x="194.667"
              y="73.9999"
              width="393.222"
              height="52.8979"
              rx="4"
              transform="rotate(16.53 194.667 73.9999)"
              fill="#FFDEEB"
            />
            <g filter="url(#filter7_ii_269_252)">
              <path
                d="M499.672 203.892C505.957 205.757 512.565 202.174 514.431 195.888C516.296 189.602 512.713 182.994 506.427 181.129C500.141 179.263 493.533 182.846 491.668 189.132C489.802 195.418 493.386 202.026 499.672 203.892Z"
                fill="#F1F3F5"
              />
              <path
                d="M505.932 197.828L504.242 197.327L505.027 194.682C505.215 194.05 505.442 193.235 504.575 192.978C503.695 192.716 503.355 193.363 503.145 194.072L502.346 196.764L500.657 196.263L502.272 190.821L503.894 191.303L503.674 192.045L503.696 192.052C504.05 191.692 504.735 191.405 505.557 191.649C507.269 192.157 507.25 193.377 506.815 194.842L505.932 197.828ZM500.587 189.511C500.043 189.349 499.738 188.78 499.898 188.24C500.058 187.7 500.627 187.389 501.169 187.55C501.712 187.711 502.019 188.281 501.859 188.822C501.698 189.362 501.128 189.671 500.587 189.511ZM499.598 195.949L497.905 195.446L499.52 190.004L501.213 190.507L499.598 195.949ZM509.661 188.36L499.942 185.476C499.477 185.338 498.991 185.593 498.855 186.048L495.959 195.807C495.825 196.261 496.091 196.741 496.557 196.88L506.274 199.763C506.739 199.901 507.228 199.647 507.363 199.192L510.259 189.433C510.394 188.977 510.123 188.498 509.661 188.36Z"
                fill="#9B6A6C"
              />
            </g>
            <g filter="url(#filter8_ii_269_252)">
              <circle
                cx="539.942"
                cy="203.459"
                r="11.8722"
                transform="rotate(16.53 539.942 203.459)"
                fill="#F1F3F5"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M542.296 196.792C540.607 196.289 538.795 196.403 537.183 197.115C535.572 197.827 534.266 199.09 533.501 200.677C532.736 202.264 532.561 204.071 533.007 205.776C533.454 207.48 534.493 208.97 535.938 209.978C536.276 210.149 536.468 209.964 536.524 209.777C536.58 209.589 536.707 209.162 536.883 208.568C534.769 208.411 534.762 206.899 534.762 206.899C534.758 206.43 534.588 205.977 534.282 205.622C533.77 204.995 534.464 205.201 534.464 205.201C534.679 205.3 534.87 205.446 535.02 205.629C535.171 205.812 535.278 206.026 535.333 206.257C535.377 206.46 535.462 206.653 535.581 206.824C535.7 206.995 535.852 207.141 536.028 207.253C536.204 207.365 536.4 207.442 536.605 207.478C536.811 207.514 537.021 207.509 537.225 207.464C537.359 207.113 537.614 206.822 537.943 206.642C536.417 205.994 534.94 204.892 535.742 202.191C535.94 201.482 536.404 200.877 537.036 200.5C537.005 199.824 537.229 199.16 537.664 198.64C537.664 198.64 538.319 198.626 539.403 199.949C540.663 199.975 541.893 200.34 542.963 201.006C544.593 200.488 545.13 200.856 545.13 200.856C545.216 201.523 545.05 202.199 544.663 202.749C544.987 203.41 545.046 204.17 544.826 204.872C544.015 207.604 542.175 207.708 540.543 207.399C540.663 207.621 540.733 207.865 540.749 208.115C540.766 208.366 540.728 208.617 540.639 208.852C540.357 209.803 540.129 210.571 540.06 210.802C539.992 211.034 540.065 211.25 540.448 211.288C542.195 211.212 543.859 210.521 545.146 209.337C546.432 208.153 547.259 206.553 547.48 204.818C547.701 203.084 547.302 201.327 546.354 199.858C545.405 198.39 543.968 197.303 542.296 196.792Z"
              fill="#9B6A6C"
            />
            <g filter="url(#filter9_ii_269_252)">
              <ellipse
                cx="466.157"
                cy="181.56"
                rx="11.8722"
                ry="11.8714"
                transform="rotate(16.53 466.157 181.56)"
                fill="#F1F3F5"
              />
            </g>
            <path
              d="M471.195 186.259L472.844 180.703C472.844 180.703 466.435 183.067 465.864 183.119C465.421 182.776 461.315 177.282 461.315 177.282L459.666 182.838C459.437 183.61 459.544 183.809 460.256 184.021L470.056 186.929C470.785 187.145 470.961 187.05 471.195 186.259ZM473.159 179.612C473.326 179.05 473.232 178.803 472.529 178.595L462.73 175.686C462.006 175.472 461.793 175.671 461.627 176.232L461.61 176.321C461.61 176.321 465.678 181.707 466.172 182.082C466.833 182.013 473.156 179.654 473.156 179.654L473.159 179.612Z"
              fill="#9B6A6C"
            />
          </g>
          <g filter="url(#filter10_ii_269_252)">
            <path
              d="M169.275 12.8098C171.174 6.4106 178.69 3.63297 184.294 7.25924L399.81 146.711C403.535 149.122 405.226 153.699 403.964 157.952L338.823 377.45C338.11 379.855 338.326 382.44 339.429 384.692L357.151 420.893C358.254 423.146 358.47 425.73 357.756 428.135L290.348 655.273C288.436 661.715 280.842 664.476 275.24 660.765L32.1427 499.771C28.4763 497.343 26.8264 492.805 28.0776 488.589L169.275 12.8098Z"
              fill="url(#paint1_radial_269_252)"
            />
          </g>
          <defs>
            <filter
              id="filter0_ii_269_252"
              x="25.4628"
              y="-1.5708"
              width="540.106"
              height="600.4"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="4" dy="-4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-4" dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter1_ii_269_252"
              x="77.4704"
              y="60.2082"
              width="519.659"
              height="518.064"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="4" dy="-4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-4" dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter2_ii_269_252"
              x="68.2152"
              y="71.2146"
              width="506.071"
              height="534.1"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="4" dy="-4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-4" dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter3_ii_269_252"
              x="175.079"
              y="168.563"
              width="337.497"
              height="188.66"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-4" dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="4" dy="-4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter4_ii_269_252"
              x="143.671"
              y="274.392"
              width="337.497"
              height="188.66"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-4" dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="4" dy="-4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter5_ii_269_252"
              x="112.262"
              y="380.222"
              width="337.497"
              height="188.66"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-4" dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="4" dy="-4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter6_ii_269_252"
              x="176.589"
              y="70.9716"
              width="398.077"
              height="168.647"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="4" dy="-4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-4" dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter7_ii_269_252"
              x="490.174"
              y="179.635"
              width="25.7505"
              height="25.7505"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-1" dy="1" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="1" dy="-1" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter8_ii_269_252"
              x="527.067"
              y="190.584"
              width="25.7505"
              height="25.7505"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-1" dy="1" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="1" dy="-1" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter9_ii_269_252"
              x="453.282"
              y="168.686"
              width="25.7504"
              height="25.7491"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-1" dy="1" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="1" dy="-1" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <filter
              id="filter10_ii_269_252"
              x="23.6635"
              y="1.64938"
              width="384.714"
              height="664.784"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="4" dy="-4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_269_252"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-4" dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_269_252"
                result="effect2_innerShadow_269_252"
              />
            </filter>
            <radialGradient
              id="paint0_radial_269_252"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(295.516 304.057) rotate(-163.471) scale(203.888 256.656)"
            >
              <stop stopColor="#68E1FD" />
              <stop offset="1" stopColor="#59C5DE" stopOpacity="0.760417" />
            </radialGradient>
            <radialGradient
              id="paint1_radial_269_252"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(229.79 334.113) rotate(-163.471) scale(149.427 304.169)"
            >
              <stop stopColor="#68E1FD" />
              <stop offset="0.984375" stopColor="#59C5DE" />
            </radialGradient>
          </defs>
        </svg>
      </svg>
    </div>
  );
}

export default FolderIcon;
